import React, { useMemo } from 'react'
import { Helmet } from 'react-helmet'

import { getAdManagerConfig, isBrowser } from '../../../../config'
const SEO = ({ title, description, data, sourceKey = 'strapiJob', metaKeywords }) => {
  const config = useMemo(() => {
    const locationPath = isBrowser() ? window.location.pathname : ''
    return getAdManagerConfig(locationPath)
  }, [])
  const seoConfig = useMemo(() => {
    const url = isBrowser()
      ? window.location.origin + window.location.pathname
      : ''
    const domain = isBrowser() ? window.location.host : ''
    return {
      url,
      domain,
    }
  })
  const imgUrl = useMemo(() => {
    if (data && data[sourceKey] && sourceKey === 'strapiArticle') {
      return (
        data[sourceKey]?.seo?.sharedImage?.url ||
        data[sourceKey]?.featured_image?.url ||
        ''
      )
    }

    return ''
  }, [data])

  return (
    <Helmet>
      <title>{data ? data[sourceKey]?.title || 'Medreps' : title}</title>
      <meta
        property="og:title"
        content={data ? data[sourceKey]?.title || '' : title}
      />
      <meta property="og:url" content={seoConfig.url} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={imgUrl} />
      <meta name="twitter:card" content="summary" />
      <meta
        name="twitter:title"
        content={data ? data[sourceKey]?.title || '' : title}
      />
      <meta property="twitter:domain" content={seoConfig.domain} />
      <meta property="twitter:url" content={seoConfig.url} />
      <meta name="twitter:image" content={imgUrl} />
      <meta
        name="description"
        content={
          description
            ? description
            : 'MedReps is the go-to job site for exclusive medical representative jobs. Industry recruiters trust MedReps to deliver quality medical sales candidates.'
        }
      />
      <meta
        name="keywords"
        content={metaKeywords || "medical sales, medical representative jobs"}
      />
      <meta name="author" content="Healthcare Staffing Technologies" />
      {data && data[sourceKey]?.google_structured_data && (
        <script type="application/ld+json">
          {JSON.stringify(data[sourceKey]?.google_structured_data)}
        </script>
      )}

      <script
        async
        src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
      ></script>
    </Helmet>
  )
}
export default SEO
